import { TrackerEvent } from './src/utils/events/tracker-factory';

declare global {
  interface Window {
    dataLayer: object[] | null;
    lucid: {
      getMetricLogger?: (
        str: string
      ) => {
        markLoaded: () => void;
        tag: (str: string, val?: string | boolean) => void;
      };
      kissMetrics?: {
        set: (val: { [x: string]: string | number }) => void;
        recordEvent: (val: string) => void;
      };
      beacon: {
        recordEvent: (evt: TrackerEvent) => void;
      };
    } | null;
  }
}

export { lucidColors } from './src/utils/lucidColors';
export {
  default as MarketoForm,
  MarketoFormInterface
} from './src/components/marketo-form/marketo-form';

export { default as BounceDetection } from './src/components/bounce-detection/bounce-detection';
export { default as Link, LinkInterface } from './src/components/link/link';
export { default as SEO } from './src/components/seo/seo';

export { useCookie } from './src/hooks/use-cookie';
export { default as useSiteMetadata } from './src/hooks/use-site-metadata';
export { default as usePathPrefix } from './src/hooks/use-path-prefix';

export { default as i18nFunct } from './src/utils/i18n';
export { MenuLink, getDrupalMenu } from './src/utils/getDrupalMenu';
export { getLinkPath } from './src/utils/getLinkPath';
export { Marketo } from './src/utils/marketo';
export { sendBeaconEvent } from './src/utils/events/send-beacon-event';
export {
  MarketingPageElementLocation,
  MarketingPageElementType
} from './src/types/beaconEventTypes';

export {
  NetworkFactory,
  NetworkResponse
} from './src/utils/network/network-factory';

export * from './src/utils/events/tracker-factory';

export { localizePhoneNumbers } from './src/utils/localizePhoneNumbers';

export interface MarketoInterface {
  getMarketoModal: (
    formId: string,
    topText?: {
      title?: string | null;
      body?: string | null;
      note?: string | null;
    },
    confirm?: {
      heading?: string | null;
      body?: string | null;
    }
  ) => void;
  getMarketoFields: (
    marketoForm: any,
    prefix: string
  ) => {
    mktoId: string | null;
    mktoFields:
      | {
          title: string | null;
          body: string | null;
          note: string | null;
        }
      | {};
  };
}
